import { render } from "./RequestHistory.vue?vue&type=template&id=061e3fd7"
import script from "./RequestHistory.vue?vue&type=script&lang=js"
export * from "./RequestHistory.vue?vue&type=script&lang=js"

import "./RequestHistory.vue?vue&type=style&index=0&id=061e3fd7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__